// Vendors
import {
  COBRANDED_LIGHT_REGULAR_BASE_STYLES,
  IconHighlightedSizeType,
} from '@openbank/ziniaweb-ui-components';
// Enumerations
import { ProofIncomeMethodsEnumeration } from 'containers/proof-income/enumerations/proof-income-methods.enumeration';

const LANDING_OPTIONS_LEFT_CONTENT_ICON_PROPS = {
    width: '24px',
    height: '24px',
    color: COBRANDED_LIGHT_REGULAR_BASE_STYLES.color_comp_lineseparator_main_bg,
  },
  LANDING_OPTIONS_LEFT_CONTENT_ICON_HIGHLIGHTED_PROPS = {
    variant: 'CIRCLE_IMAGE',
    altText: 'Icon Highlighted label',
    size: IconHighlightedSizeType.SMALL,
  },
  LANDING_OPTIONS_LEFT_CONTENT_ICONS = {
    [ProofIncomeMethodsEnumeration.OPENBANKING]: 'icon_categories_organizations-and-ongs',
    [ProofIncomeMethodsEnumeration.TGSS]: 'icon_documents_transactions',
  };

export {
  LANDING_OPTIONS_LEFT_CONTENT_ICON_PROPS,
  LANDING_OPTIONS_LEFT_CONTENT_ICON_HIGHLIGHTED_PROPS,
  LANDING_OPTIONS_LEFT_CONTENT_ICONS,
};
